module.exports = __webpack_public_path__ + "img/fun.23f44a45.png";